<template>
  <div>

   <iframe src="https://docs.google.com/document/d/e/2PACX-1vTAVrdij7AdNYxsTxK80R8Jp_5bEyLW7ZDhPK95kMtm4SbqZ-Ya8IBeHBA3MOht7NAsNRlnYEleuads/pub?embedded=true" width="100%" height="650px"></iframe>   

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>